import { createCookie, eraseCookie, readCookie } from '@talos/kyoko';

const UI_CHANNEL_COOKIE = 'ui_channel';
const UI_CHANNEL_OVERRIDE_COOKIE = 'ui_channel_override';

export const UI_CHANNELS = ['stable', 'rapid', 'experimental'] as const;
type UIChannel = (typeof UI_CHANNELS)[number];

export const isValidUIChannel = (value: string): value is UIChannel => {
  return UI_CHANNELS.includes(value as UIChannel);
};

export function getUIChannel(): string {
  const uiChannelOverride = getOverrideUIChannel();
  if (uiChannelOverride) {
    return uiChannelOverride;
  }
  return getBaseUIChannel();
}

export function getBaseUIChannel(): string {
  return getChannelFromCookie(UI_CHANNEL_COOKIE);
}

export function getOverrideUIChannel(): string {
  return getChannelFromCookie(UI_CHANNEL_OVERRIDE_COOKIE);
}

export function getChannelFromCookie(cookieName: string): string {
  const channelCookie = readCookie(cookieName);
  if (channelCookie && isValidUIChannel(channelCookie)) {
    return channelCookie;
  }
  return '';
}

export function overrideUIChannel(channel: string) {
  const baseChannel = getBaseUIChannel();

  // If overriding to the same value as the base channel, just remove the override
  if (baseChannel === channel) {
    removeUIChannelOverride();
  } else {
    createUIChannelOverride(channel);
  }
}

function createUIChannelOverride(channel: string) {
  createCookie(UI_CHANNEL_OVERRIDE_COOKIE, channel);
}

export function removeUIChannelOverride() {
  eraseCookie(UI_CHANNEL_OVERRIDE_COOKIE);
}
